import React, { useEffect } from "react";
import { Container } from "@material-ui/core";
import styled from "styled-components";
import Layout from "../../Shared/Layout";
import { Trans } from "../../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import { usePage, InertiaLink, } from "@inertiajs/inertia-react";
import DeviceWidget from "../../FormComponents/DeviceWidget/DeviceWidget";
import {CheckCircle} from "@material-ui/icons";
import { useShoppingCartStore } from "../../stores/ShoppingCartStore";

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const SuccessWrapper = styled.div`
    padding: 1rem 1rem;
    margin-left: 25%;
    margin-right: 25%;
    margin-top: 3rem;
    margin-bottom: 3rem;
    border-radius: .5rem;
    text-align: center;
    color: #000;
`;

export default function OrderSuccessPage({ orderNumber }) {
    const { client, widgetData, products = [] } = usePage().props;

    const shoppingCartStore = useShoppingCartStore();

    useEffect(() => {
            shoppingCartStore.send({
                type: "clearCart",
            });
        }, []
    );

    return (
        <Wrapper>
            <Container maxWidth="md">
                <div className={'bg-blue-200 rounded-lg font-bold text-center p-1.5 text-lg mb-6 flex gap-2 justify-center items-center text-gray-900'}>
                    <CheckCircle />
                    <Trans i18nKey="order.confirmedRequest">
                        Confirmed request
                    </Trans>
                </div>
                <DeviceWidget values={widgetData} products={products} hideBadge={true} />
                <h2>
                    <Trans i18nKey="formPage.yourOrderHasBeenPlaced">
                        Your Order has been placed
                    </Trans>
                </h2>
                <SuccessWrapper className={'bg-blue-100'}>
                    <p>
                        <Trans i18nKey="formPage.thanksForYourPartsShopOrder">
                            Thanks for your Order
                        </Trans>
                    </p>
                    <p>
                        <b>{orderNumber}</b>
                    </p>
                </SuccessWrapper>
                <div className={'text-right'}>
                    <MuiButton
                        style={{ marginTop: 50}}
                        variant="contained"
                        color={"secondary"}
                        href={'/'}
                        component={InertiaLink}
                    >
                        <Trans i18nKey="common.home">
                            Home
                        </Trans>
                    </MuiButton>
                </div>
            </Container>
        </Wrapper>
    );
}

OrderSuccessPage.layout = (page) => <Layout children={page} />;
